import { createContext } from 'react'

export type PairExploreItemContextValue = {
  withHide?: boolean
}

export const PairExploreItemContext =
  createContext<PairExploreItemContextValue>({
    withHide: false,
  })
